<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Manage Type'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div v-if="manageTypeList.length > 0" class="filter-settings scrollbar">
        <div v-for="(manageType, index) in manageTypeList" :key="`${manageType.value}-${index}`" class="filter-settings__row">
          <input
            :id="`taskManageTypeFilter-${manageType.value}-${index}`"
            v-model="selectedManageTypes"
            type="checkbox"
            :name="'selected-manage-types'"
            :value="manageType.value"
          >
          <label :for="`taskManageTypeFilter-${manageType.value}-${index}`">{{ manageType.key }}</label>
        </div>
      </div>
      <div v-else class="filter-settings">
        No manage types available.
      </div>
      <div class="filter-footer">
        <button class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script setup>
import { computed } from 'vue';
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

const props = defineProps({
  manageTypeList: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedManageTypes = computed({
  get() {
    return Array.isArray(props.modelValue) ? props.modelValue : [];
  },
  set(value) {
    emit('update:modelValue', Array.isArray(value) ? value : []);
  },
});

const isActive = computed(() => selectedManageTypes.value.length > 0);
const tagValue = computed(() => selectedManageTypes.value.length.toString());

const clearSelection = () => {
  emit('update:modelValue', []);
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 200px;
  overflow: auto;

  &__row {
    display: flex;
    align-items: center;
  }

  & input[type=checkbox] {
    margin-right: 12px;
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }

    &[disabled] {
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}
</style>
